import { css } from '@emotion/react';

export const getBottomSafeAreaPadding = (bottomPadding?: number) => css`
  padding-bottom: calc(constant(safe-area-inset-bottom) + ${bottomPadding || 0}px);
  padding-bottom: calc(env(safe-area-inset-bottom) + ${bottomPadding || 0}px);
`;
